import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import CategoryDetailsCard from '@/components/v2/ecommerce/CategoryDetailsCard';
import ProductViewManager from '@/components/v2/ecommerce/ProductViewManager.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import SubCategories from '@/components/v2/ecommerce/CategorySubCategories.vue';
import InquirySubCategoriesManager from '@/components/v2/inquiry/SubCategoriesViewManager.vue';
import Category from '@/plugins/graphql/queries/v2/category-details.gql';
import { CategoryModel } from '@/helpers/entities/models/CategoryModel';
let CategoryDetails = class CategoryDetails extends Vue {
    constructor() {
        super(...arguments);
        this.category = null;
    }
};
__decorate([
    Prop({ type: String, required: true })
], CategoryDetails.prototype, "uuid", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CategoryDetails.prototype, "ecommerce", void 0);
__decorate([
    Prop({ type: String, required: true })
], CategoryDetails.prototype, "editRouteName", void 0);
CategoryDetails = __decorate([
    Component({
        components: {
            PageTitle,
            CategoryDetailsCard,
            InquirySubCategoriesManager,
            SubCategories,
            ProductViewManager,
            BaseSubtitle,
        },
        apollo: {
            category: {
                query: Category,
                variables() {
                    const categoryUuid = this.uuid;
                    return {
                        categoryUuid,
                    };
                },
                update(data) {
                    return new CategoryModel(data.category);
                },
            },
        },
    })
], CategoryDetails);
export default CategoryDetails;
